import { render, staticRenderFns } from "./paypal-form.vue?vue&type=template&id=2c3b8db7&scoped=true&"
import script from "./paypal-form.vue?vue&type=script&lang=js&"
export * from "./paypal-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3b8db7",
  null
  
)

export default component.exports